export const voices = [
  ["texto", "Texto"], ["pt-BR-FranciscaNeural", "Francisca"], ["pt-BR-AntonioNeural", "Antônio"],
  ["pt-BR-BrendaNeural", "Brenda"], ["pt-BR-DonatoNeural", "Donato"], ["pt-BR-ElzaNeural", "Elza"],
  ["pt-BR-FabioNeural", "Fábio"], ["pt-BR-GiovannaNeural", "Giovanna"], ["pt-BR-HumbertoNeural", "Humberto"],
  ["pt-BR-JulioNeural", "Julio"], ["pt-BR-LeilaNeural", "Leila"], ["pt-BR-LeticiaNeural", "Letícia"],
  ["pt-BR-ManuelaNeural", "Manuela"], ["pt-BR-NicolauNeural", "Nicolau"], ["pt-BR-ValerioNeural", "Valério"], ["pt-BR-YaraNeural", "Yara"]
];
export const voiceLabel = value => voices.find(([id]) => id === value)?.[1] || value || "Texto";
export const normalizePrompt = (data = {}) => ({
  name: data.name || "", prompt: data.prompt || "", queueId: data.queueId || "",
  apiKey: "", voiceKey: "", hasApiKey: Boolean(data.hasApiKey || data.apiKey), hasVoiceKey: Boolean(data.hasVoiceKey || data.voiceKey),
  voice: data.voice || "texto", voiceRegion: data.voiceRegion || "",
  maxTokens: data.maxTokens == null ? 100 : data.maxTokens,
  maxMessages: data.maxMessages == null ? 10 : data.maxMessages,
  temperature: data.temperature == null ? 1 : data.temperature
});
const numeric = value => String(value).trim() === "" ? NaN : Number(String(value).replace(",", "."));
export function validatePrompt(values) {
  const errors = {};
  if (!values.name.trim()) errors.name = "Informe o nome do assistente.";
  else if (values.name.trim().length > 100) errors.name = "Use até 100 caracteres.";
  if (!values.prompt.trim()) errors.prompt = "Informe as instruções do assistente.";
  if (!Number.isInteger(Number(values.queueId)) || Number(values.queueId) <= 0) errors.queueId = "Selecione a fila de transferência.";
  if (!values.hasApiKey && !values.apiKey.trim()) errors.apiKey = "Informe a chave OpenAI.";
  if (!values.voice) errors.voice = "Selecione o formato de resposta.";
  if (values.voice && values.voice !== "texto") {
    if (!values.hasVoiceKey && !values.voiceKey.trim()) errors.voiceKey = "Informe a chave de voz.";
    if (!values.voiceRegion.trim()) errors.voiceRegion = "Informe a região de voz.";
    else if (!/^[a-z][a-z0-9]*$/.test(values.voiceRegion.trim())) errors.voiceRegion = "Informe uma região válida da Azure.";
  }
  const tokens = numeric(values.maxTokens), history = numeric(values.maxMessages), temperature = numeric(values.temperature);
  if (!Number.isInteger(tokens) || tokens <= 0 || tokens > 2147483647) errors.maxTokens = "Use um número inteiro maior que zero.";
  if (!Number.isInteger(history) || history < 0 || history > 2147483647) errors.maxMessages = "Use um número inteiro a partir de zero.";
  if (!Number.isFinite(temperature) || temperature < 0 || temperature > 2) errors.temperature = "Use um valor entre 0 e 2.";
  return errors;
}
export function promptPayload(values) {
  const payload = {
    name: values.name.trim(), prompt: values.prompt.trim(), queueId: Number(values.queueId), voice: values.voice,
    voiceRegion: values.voiceRegion.trim(), maxTokens: numeric(values.maxTokens), maxMessages: numeric(values.maxMessages), temperature: numeric(values.temperature)
  };
  if (values.apiKey.trim()) payload.apiKey = values.apiKey.trim();
  if (values.voiceKey.trim()) payload.voiceKey = values.voiceKey.trim();
  return payload;
}
export const fieldTab = field => ["apiKey", "voice", "voiceKey", "voiceRegion"].includes(field) ? 1 : ["maxTokens", "maxMessages", "temperature"].includes(field) ? 2 : 0;
